import { render, staticRenderFns } from "./RelatedQuestionsUserText.vue?vue&type=template&id=ea31f8f8&scoped=true"
import script from "./RelatedQuestionsUserText.vue?vue&type=script&lang=js"
export * from "./RelatedQuestionsUserText.vue?vue&type=script&lang=js"
import style0 from "./RelatedQuestionsUserText.vue?vue&type=style&index=0&id=ea31f8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea31f8f8",
  null
  
)

export default component.exports